import { config } from '@iheartjane/config';
import { useQuery } from '@tanstack/react-query';

import { api } from '@jane/shared/data-access';

interface StaticContent {
  text?: string;
}

const fetchTermsOfService = (): Promise<StaticContent> =>
  api.get(`${config.apiPath}/terms_of_service`);
export const useTermsOfService = () =>
  useQuery({
    queryKey: ['terms_of_service'],
    queryFn: fetchTermsOfService,
    staleTime: Infinity,
  });
